import React from 'react';

import useKnowledgeBaseEnabled from './hooks/useKnowledgeBaseEnabled';
import useOpenCoachDrawer from './hooks/useOpenCoachDrawer';
import { CoachOrbButton } from './CoachOrbButton';
import CoachRightDrawer from './CoachRightDrawer';

function KnowledgeBase({ className }: { className?: string }) {
  const { isCoachOpen, openCoach, closeCoach } = useOpenCoachDrawer({
    syncInQueryParam: true,
  });

  const isKnowledgeBaseEnabled = useKnowledgeBaseEnabled();

  if (!isKnowledgeBaseEnabled) {
    return null;
  }

  return (
    <>
      <CoachOrbButton onClick={openCoach} />
      <CoachRightDrawer isOpen={isCoachOpen} onClose={closeCoach} />
    </>
  );
}

export default React.memo(KnowledgeBase);
